import { useCallback, useEffect, useState } from 'react'
import {
  defaultContactSettings,
  getContactSettings,
  saveContactSettings,
  subscribeContactSettings,
  type ContactSettings,
} from '../data/contactSettings'

export function useContactSettings() {
  const [settings, setSettings] = useState<ContactSettings>(() => getContactSettings())

  useEffect(() => subscribeContactSettings(setSettings), [])

  const saveSettings = useCallback((nextSettings: ContactSettings) => {
    saveContactSettings(nextSettings)
    setSettings(nextSettings)
  }, [])

  const resetSettings = useCallback(() => {
    saveContactSettings(defaultContactSettings)
    setSettings(defaultContactSettings)
  }, [])

  return { settings, saveSettings, resetSettings }
}
